<ng-container *ngFor="let company of companyList; index as i; trackBy: trackByCompanyID">
  <div
    [id]="company.id"
    class="company is-animated"
    (click)="showCompany($event, company)"
    [ngClass]="{
      active: selectedCompanyID === company.id,
      'is-loading': loadingID === company.id,
      'is-disabled': loadingID && loadingID !== company.id
    }"
  >
    <div>
      <h4>
        {{ company.name }}&nbsp;<span *ngIf="stepStatus === 5 && !enabledActions">{{ company.stock_ratio | percent: '1.0-1' }}</span>
      </h4>
      <div class="company-topics">
        <ng-container *ngIf="company.criteria_dismatch?.length === 0; else criteriaDismatchPresent">
          <ng-container *ngFor="let topic of company.topics | slice: 0 : maxElements">
            <app-ui-tooltip
              [icon]="topic.icon"
              [content]="topic.desc"
              [title]="topic.name"
              size="large"
              (mouseenter)="trackTooltip(topic.name)"
            ></app-ui-tooltip>
          </ng-container>
          <div class="stability" *ngIf="company.topics?.length === 0">
            <ng-container *ngIf="view === 'portfolio'; else stabilityPersonalise">
              <app-ui-tooltip
                (click)="openWhyInyova($event)"
                icon="/assets/images/stability.svg"
                [content]="'<a>' + ('learn_more' | translate) + '</a>'"
                [title]="'new_strategy.portfolio_screen.stock_ratio.stock.popup.title' | translate"
                size="large"
                (mouseenter)="trackTooltip('stability')"
              ></app-ui-tooltip>
            </ng-container>
            <ng-template #stabilityPersonalise>
              <ng-container *ngIf="activeTab === 'inyovaStocks'; else showFinalStability">
                <ng-container *ngFor="let additionalTopic of company.additional_topics | slice: 0 : maxElements">
                  <app-ui-tooltip
                    [icon]="additionalTopic.icon"
                    [content]="additionalTopic.desc"
                    [title]="additionalTopic.name"
                    size="large"
                  ></app-ui-tooltip>
                </ng-container>
              </ng-container>
              <ng-template #showFinalStability>
                <app-ui-tooltip
                  icon="/assets/images/stability.svg"
                  [content]="'new_strategy.personalise.recommendations.tooltip.stability.p' | translate"
                  [title]="'new_strategy.portfolio_screen.stock_ratio.stock.popup.title' | translate"
                  size="large"
                ></app-ui-tooltip>
              </ng-template>
            </ng-template>
          </div>
        </ng-container>
        <ng-template #criteriaDismatchPresent>
          <app-ui-tooltip
            [icon]="'/assets/images/icons/yellow-warning.svg'"
            [content]="getWarningCopy(company.criteria_dismatch)"
            size="medium"
            (mouseenter)="trackTooltip('warning')"
          ></app-ui-tooltip>
          <ng-container *ngFor="let wished_criterium of company.criteria_dismatch | slice: 0 : maxElements - 1">
            <app-ui-tooltip
              [icon]="wished_criterium.icon"
              [title]="wished_criterium.name"
              [content]="wished_criterium.desc"
              size="large"
              (mouseenter)="trackTooltip(wished_criterium.name)"
            ></app-ui-tooltip>
          </ng-container>
        </ng-template>
      </div>
    </div>

    <app-strategy-company-actions
      *ngIf="enabledActions && view !== 'portfolio'"
      [activeTab]="activeTab"
      [blockedCompaniesIDs]="blockedCompaniesIDs"
      [company]="company"
      [listType]="listType"
      [selectedCompanyID]="selectedCompanyID"
      [wishedCompaniesIDs]="wishedCompaniesIDs"
      [mobileView]="isMobile"
      [location]="'list'"
      [showExcludedAction]="activeTab !== 'inyovaStocks'"
      (updateLoadingID)="updateLoadingCompany($event)"
    ></app-strategy-company-actions>
    <div class="portfolio-list-actions" *ngIf="view === 'portfolio'">
      <div class="wished" *ngIf="listType === 'wishlist'"></div>
      <div class="chevron" [ngClass]="{ open: selectedCompanyID === company.id }"></div>
    </div>
  </div>
  <div *ngIf="selectedCompanyID === company.id">
    <ng-content></ng-content>
  </div>
</ng-container>
